import supabase from "artifact/supabase";
import args from "standard/args";
import connected from "standard/connected";
import define from "standard/define";
import filter from "standard/filter";
import on from "standard/on";
import paint from "standard/paint";
import trait from "standard/trait";
import style from "./style";

@define("m-resend-email")
class ResendEmail extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <a class='${style.resendEmail}' href='/oauth/check-your-email?email=${args.email}'>
        Clique para reenviar
      </a>
    `;
  }

  @on.click("a")
  @filter.prevent
  async [trait.onClick]() {
    const redirectTo = "https://memoize.cards/set-new-password";
    const { data, error } = await supabase.auth.resetPasswordForEmail(
      args.email,
      {
        redirectTo,
      },
    );

    error
      ? console.log(error.message)
      : location.assign(`/oauth/check-your-email?email=${args.email}`);

    return this;
  }
}

export default ResendEmail;
